import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthService } from '../auth.service';
import { DataService } from '../data/data.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  password: string;
  passwordConfirm: string;
  resetting = null;
  reset = false;
  token: string;
  tokenValid = false;
  verifyingToken = true;
  welcome = false;

  passwordErrors: { length, upper, lower, other } = { length: false, upper: false, lower: false, other: false };

  constructor(
    protected authService: AuthService,
    private dataService: DataService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.welcome = params.welcome;
      this.verifyToken();
    });
  }

  resetPassword() {
    if (this.password) {
      if (this.password != this.passwordConfirm) {
        swal.fire('Oops!', 'The passwords do not match.', 'error');
      }
      else {
        this.resetting = true;
        this.dataService.resetPassword(this.password, this.token).subscribe({
          next: response => {
            if (!response || !response.Success) {
              swal.fire('Oops!', "Your password didn't meet our requirements", 'error');
              this.passwordErrors = { length: true, upper: true, lower: true, other: true }
              this.resetting = false;
            }
            else {
              this.reset = true;
              this.authService.logout();
            }
          }
        });
      }
    }
  }

  validatePassword() {
    if (!this.password) this.passwordErrors = { length: false, upper: false, lower: false, other: false };
    else this.passwordErrors = { 
      length: this.password.length < 8,
      upper: !this.password.match(/[A-Z]/),
      lower: !this.password.match(/[a-z]/),
      other: !this.password.match(/[^a-zA-Z]/)
    }
  }

  verifyToken() {
    this.dataService.verifyResetPasswordToken(this.token).subscribe(response => {
      this.tokenValid = response.Valid;
      this.verifyingToken = false;
    })
  }
}
